import React, { useEffect } from 'react';

const PrivacyPolicyModal = ({ onClose }) => {
  useEffect(() => {
    // Disable background scroll when modal is open
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="property-modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}>
      <div 
        className="privacy-modal-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#0d1527',
          color: '#e2e8f0',
          width: '90%',
          maxWidth: '750px',
          maxHeight: '85vh',
          borderRadius: '12px',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.6)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          animation: 'fadeInModal 0.25s ease-out'
        }}
      >
        {/* Modal Header */}
        <div style={{
          padding: '1.25rem 1.75rem',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#090d16'
        }}>
          <div>
            <h2 style={{ color: '#d4af37', margin: 0, fontSize: '1.35rem', fontFamily: 'Outfit, sans-serif', fontWeight: 700 }}>
              PRIVACY POLICY
            </h2>
            <p style={{ color: '#94a3b8', margin: '4px 0 0 0', fontSize: '0.8rem' }}>
              Personal Data Protection Notice (PDPA Compliance)
            </p>
          </div>
          <button 
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.08)',
              border: 'none',
              color: '#ffffff',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.2rem',
              transition: 'all 0.2s ease'
            }}
            aria-label="Close Privacy Policy"
          >
            <i className="bi bi-x"></i>
          </button>
        </div>

        {/* Modal Body / Scrollable content */}
        <div style={{
          padding: '1.75rem',
          overflowY: 'auto',
          fontSize: '0.9rem',
          lineHeight: '1.6',
          color: '#cbd5e1'
        }}>
          <section style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              1. Introduction & Overview
            </h3>
            <p style={{ margin: 0 }}>
              Nicole Pua Property Agent ("we", "us", or "our") is committed to protecting your privacy in accordance with Malaysia's Personal Data Protection Act 2010 (PDPA). This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website or engage our real estate services.
            </p>
          </section>

          <section style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              2. Information We Collect
            </h3>
            <p style={{ marginBottom: '0.5rem' }}>
              We collect information that you voluntarily provide to us when inquiring about property listings, scheduling viewings, or requesting consultations. This information may include:
            </p>
            <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
              <li>Full Name and Contact Information (Phone Number, WhatsApp Number, Email Address)</li>
              <li>Property preferences, search criteria, budget, and location choices</li>
              <li>Inquiry notes, viewing feedback, and transaction details</li>
              <li>Technical data such as IP address, browser type, and page interaction metrics for site analytics</li>
            </ul>
          </section>

          <section style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              3. How We Use Your Personal Data
            </h3>
            <p style={{ marginBottom: '0.5rem' }}>
              Your personal data is strictly used for legitimate real estate consulting purposes, including:
            </p>
            <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
              <li>Responding to property inquiries and arranging property viewings</li>
              <li>Providing personalized advice on residential and commercial real estate in Johor Bahru</li>
              <li>Sending property recommendations, new project launch notifications, and market updates</li>
              <li>Complying with applicable legal obligations and Malaysian Board of Valuers, Appraisers, Estate Agents and Property Managers (BOVAEP) standards</li>
            </ul>
          </section>

          <section style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              4. Data Protection & Confidentiality
            </h3>
            <p style={{ margin: 0 }}>
              We implement reasonable security measures to maintain the safety of your personal information. We do not sell, rent, trade, or share your personal information with third-party marketing agencies. Your information will only be shared with authorized entities (such as developers, lawyers, or bankers) when necessary to facilitate your property transaction with your prior consent.
            </p>
          </section>

          <section style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              5. Third-Party Links & Services
            </h3>
            <p style={{ margin: 0 }}>
              Our website contains links to third-party services such as WhatsApp and Google Maps. We encourage you to review the privacy policies of any third-party services you access through our site, as we do not control their content or security policies.
            </p>
          </section>

          <section style={{ marginBottom: '0.5rem' }}>
            <h3 style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '0.5rem', fontWeight: 600 }}>
              6. Contact Us & Your Rights
            </h3>
            <p style={{ marginBottom: '0.75rem' }}>
              You have the right to request access to, correction of, or removal of your personal data from our records at any time. For any privacy-related inquiries, please contact:
            </p>
            <div style={{
              background: '#101826',
              padding: '1rem',
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.08)'
            }}>
              <p style={{ margin: '0 0 4px 0', fontWeight: 600, color: '#ffffff' }}>Nicole Pua (Registered Real Estate Negotiator)</p>
              <p style={{ margin: '0 0 4px 0', fontSize: '0.85rem' }}><i className="bi bi-telephone" style={{ color: '#d4af37', marginRight: '6px' }}></i> +6016-3288 120</p>
              <p style={{ margin: 0, fontSize: '0.85rem' }}><i className="bi bi-envelope" style={{ color: '#d4af37', marginRight: '6px' }}></i> nicolepua.property@gmail.com</p>
            </div>
          </section>
        </div>

        {/* Modal Footer */}
        <div style={{
          padding: '1rem 1.75rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          justifyContent: 'flex-end',
          background: '#090d16'
        }}>
          <button 
            onClick={onClose}
            style={{
              background: '#d4af37',
              color: '#000000',
              border: 'none',
              padding: '0.5rem 1.5rem',
              borderRadius: '6px',
              fontWeight: 700,
              cursor: 'pointer',
              fontSize: '0.85rem'
            }}
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
